const appConfig = {
  ASSETS_BUCKET: 'https://storage.googleapis.com/hom-frontend-assets/',
}

export default appConfig
